<div class="text-right h3 btn btn-primary float-left"><span class="fa fa-download" (click)="exportReport()"  title="Download Excel"></span></div>
<table style="table-layout: fixed; width: 100%;" class="table table-xs tableFixHead" id="asset-report" *ngIf="reportData.length > 0">
    <thead>
        <tr>
            <th>#</th>
            <th>Plate#</th>
            <th>Engine#</th>
            <th>Device IMEI</th>
            <th>Chassis Number</th>
            <th>Installation Date</th>
            <th>Group</th>
            <th>Status</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let asset of reportData ;let index=index">
            <td>{{ index + 1 }}</td>
            <td>{{ asset.plate_number ? asset.plate_number:'N/A' }}</td>
            <td>{{ asset.engine_number ? asset.engine_number:'N/A' }}</td>
            <td>{{ asset.imei ? asset.imei:'N/A' }}</td>
            <td>{{ asset.chassis_number ? asset.chassis_number:'N/A' }}</td>
            <td>{{ asset.installation_date ? (asset.installation_date | date : 'dd/MM/yyyy hh:mm:ss a') :'' }}</td>
            <td>{{ asset.name ? asset.name:'Not Assigned' }}</td>
            <td>
                <span class="badge" [ngClass]="asset.translated_status.class">
                    {{ asset.translated_status.val }}
                </span>
            </td>
        </tr>
    </tbody>
</table>
